<template>
  <div>
    <dd-button
        v-if="runningAutomation"
        :small="true"
        :square="true"
        :outline="true"
    >
      <template #icon>
        <dd-loading-indicator :no-message="true" size="sm"/>
      </template>
    </dd-button>
    <dd-button
        v-else-if="failed"
        :outline="true"
        type="danger"
        :small="true"
        :square="true"
    >
      <template #icon>
        <CancelIcon class="icon-size-lg fill-danger"/>
      </template>
    </dd-button>
    <dd-confirm-modal
        v-else-if="!runningAutomation &&  !failed"
        title="Automation uitvoeren"
        :description="`Wil je de automation '${automationInterface.title || ''}' eenmalig uitvoeren?`"
        ok-text="Uitvoeren"
        cancel-text="Annuleren"
        @confirm="onClick"
    >
      <dd-button
          :small="true"
          :outline="true"
          class="square-button"
      >
        <template #icon>
          <PlayIcon class="icon-size-lg fill-primary icon-offset-zero"></PlayIcon>
        </template>
      </dd-button>
    </dd-confirm-modal>
  </div>

</template>

<script>
import globalAutomationConfigurationApi from "~/api/global_automation_configuration";
import automationApi from "~/api/automation";
import { AutomationHelper, GlobalAutomationHelper } from "~/pages/automation/helpers";
import automation_interface from "~/api/automation_interface";
export default {
  props: {
    automationInterface: {
      type: Object,
      required: true
    },
  },
  computed: {
    isGlobalActive() {
      return GlobalAutomationHelper.isActive(this.automationInterface);
    },
    isActive() {
      return this.isGlobal ? this.isGlobalActive :  AutomationHelper.isActive(this.automationInterface);
    },
    isGlobal() {
      return !!this.automationInterface.global_automation_id;
    },
  },
  data() {
    return {
      popoverVisible: false,
      run_interval: this.automationInterface.run_interval,
      failed: false,
      runningAutomation: false,
    };
  },
  methods: {
    onClick() {
      let promise;
      if (this.isGlobal) {
        promise = globalAutomationConfigurationApi.run(this.automationInterface.id)
      }
      else {
        promise = automationApi.run(this.automationInterface.id)
      }
      promise.then(() => {
        this.runningAutomation = true;

        // TODO: Replace this with feedback from pusher
        setTimeout(() => {
          this.runningAutomation = false;
        }, 300);
      }).catch((error) => {
        this.failed = true;
        setTimeout(() => {
          this.failed = false;
        }, 500);
      });
    },
    submit() {
      // Do api call to activate automation
      // Reload the page, because order of automations might have changed
      // close the popover
      this.popoverVisible = false;
    },
  },
};
</script>


<style scoped>

</style>
